import { isFlightActiveFilter } from "./is-flight-active";

let filterModule = angular.module("sdApp.Filter", []).filter("sdIsFlightActive", isFlightActiveFilter);

export default filterModule;
